"use client"
import { animate, motion, useMotionValue, useTransform } from "motion/react"
import {useEffect, useState} from "react"
import {DriveUtil} from "@/Master/DriveUtil";
import {toFixedFormat} from "@/app/utils/tool";
import  styles from  "./NumberScroll.module.css"

type NumberScrollProps = {
    value: number,
    type?: string,
}

export default function NumberScroll(props: NumberScrollProps) {
    const { value, type } = props

    const count = useMotionValue(0)

    let rounded;
    if (type === 'gcCoin') {
        rounded = useTransform(() => Math.round(count.get()))
    } else if (type === 'scCoin') {
        rounded = useTransform(() => count.get().toFixed(4))
    } else {
        rounded = useTransform(() => Math.round(count.get()))
    }
    // const rounded = useTransform(() => count.get())

    const [hasAnimated, setHasAnimated] = useState(false)

    useEffect(() => {
        const controls = animate(count, value, { duration: 1 })
        controls.then(() => {
            setHasAnimated(true)
        })

        return () => {
            controls.cancel()
            controls.stop()
            count.set(0)
            setHasAnimated(false)
        }
    }, [value])

    // const handleAnimate = () => {
    //     animate(count, 1000, { duration: 3 })
    // }
    //
    // const handleTestPlus = () => {
    //     animate(count, 100, { duration: 3 })
    // }

    return (
        <>
            {!hasAnimated && <motion.pre className={styles.wrapper}>{rounded}</motion.pre>}
            {type === "scCoin" && hasAnimated && toFixedFormat(value || 0)}
            {type === "gcCoin" && hasAnimated && DriveUtil.ToGcString(value || 0)}
            {/*<button onClick={handleAnimate}>test</button>*/}
            {/*<button onClick={handleTestPlus}>testPlus</button>*/}
        </>
    )
}